import React from "react";
import { Flex } from "rebass";
import styled from "styled-components";

const TagList = styled(Flex)`
  flex-wrap: wrap;

  > * {
    margin-right: 2px;
    margin-bottom: 2px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

TagList.defaultProps = {};

export default TagList;



// WEBPACK FOOTER //
// ./src/components/TagList.js